import * as Yup from 'yup'
import {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'
import apiConnect from '../../api/apiConnect'
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useUser} from '../../modules/newauth/UserContext'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import Select from 'react-select'

const CreateNewParameter = () => {
  const deviceId = useParams().deviceId
  const {user} = useUser()
  const navigate = useNavigate()

  const [parameterType, setParameterType] = useState('')
  const [unitLists, setUnitLists] = useState([])
  const [iconUrl, setIconUrl] = useState('') // State สำหรับจัดการ icon URL
  const [deviceData, setDeviceData] = useState([])
  const [selectedUnit, setSelectedUnit] = useState(null)
  const [parameterUnit, setParameterUnit] = useState('') // State สำหรับเก็บ parameterUnit
  const [parameterName, setParameterName] = useState('') // State สำหรับเก็บ parameterUnit
  const [parameterOwner, setParameterOwner] = useState('') // State สำหรับเก็บ parameterUnit

  const parameterOptions = [
    {value: '', label: 'Select a parameter type...'},
    {value: 'parameter', label: 'Parameter'},
    {value: 'setting_parameter', label: 'Setting Parameter'},
    {value: 'status_parameter', label: 'Status Parameter'},
  ]

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/by-device-id/${deviceId}`)

        // Check Device ID
        if (response?.data?.status == 'error' && response?.data?.text == 'No such document!') {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Device not found!',
          }).then(() => {
            navigate(`/device/${deviceId}`)
          })
        }

        // Check Device Limit
        if (response?.data?.limitParameter) {
          const countAllParameter =
            response?.data?.digital_output?.length +
            response?.data?.sensor?.length +
            response?.data?.setting_parameter?.length +
            response?.data?.status_parameter?.length
          // console.log(countAllParameter)
          // console.log(response?.data?.limitParameter)

          if (countAllParameter >= response?.data?.limitParameter) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You have reached the maximum number of parameters for this device.',
            }).then(() => {
              navigate(`/device/${deviceId}`)
            })
          }
        }

        // Check Device Owner
        if (user?.role == 'user') {
          if (response?.data?.owner !== user?.userIdMalin1) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You are not the owner of this device.',
            }).then(() => {
              navigate(`/device/${deviceId}`)
            })
          }
        }

        setDeviceData(response.data)
        setParameterOwner(response.data.owner)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/units/all-unit/`)

        const sortedUnits = response.data.sort((a, b) => {
          if (a.quantity_name < b.quantity_name) return -1
          if (a.quantity_name > b.quantity_name) return 1
          return 0
        })

        setUnitLists(sortedUnits)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    const selectedUnit = unitLists.find((unit) => unit.unit_id === parameterUnit)
    if (selectedUnit) {
      if (deviceData.premium) {
        setIconUrl(selectedUnit.premium_parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      } else {
        setIconUrl(selectedUnit.parameter_icon) // อัปเดต URL รูปจาก unitLists
        setSelectedUnit(selectedUnit) // อัปเดตค่า selectedUnit
      }
    } else {
      setIconUrl('') // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
      setSelectedUnit(null) // ตั้งค่าเริ่มต้นหากไม่มีการเลือก
    }
  }, [parameterUnit, unitLists]) // เพิ่ม parameterUnit เป็น dependency

  // const handleParameterUnitChange = (e) => {
  //   setParameterUnit(e.target.value) // อัปเดตค่า parameterUnit เมื่อเลือก
  // }

  const handleCreateParameter = async () => {
    if (parameterType === 'parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl: deviceData.premium
          ? selectedUnit.premium_parameter_icon
          : selectedUnit.parameter_icon,
        name: parameterName,
        ownerId: parameterOwner,
        unitFormat: selectedUnit.unit_symbol,
        unitId: selectedUnit.unit_id,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post('/v1/parameters/create-new-parameter', payload)
        Swal.fire({
          icon: 'success',
          title: 'Create new parameter successfully!',
          html: `<div>
                  <p>Parameter Name : ${response.data.data.name}</p>
                  <p>Parameter ID : ${response.data.data.parameterId}</p>
               </div>`,
        }).then(() => {
          navigate(`/device/${deviceId}`)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    } else if (parameterType === 'setting_parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl: deviceData.premium
          ? 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter_premium.png?alt=media&token=2617106e-4985-4347-96e5-523d62c50bad'
          : 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter.png?alt=media&token=7e3655c7-3ef6-4287-8610-8fbf133d41ee',
        name: parameterName,
        ownerId: parameterOwner,
        unitFormat: selectedUnit.unit_symbol,
        unitId: selectedUnit.unit_id,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post(
          '/v1/setting-parameters/create-new-setting-parameter',
          payload
        )
        Swal.fire({
          icon: 'success',
          title: 'Create new parameter successfully!',
          html: `<div>
                  <p>Parameter Name : ${response.data.data.name}</p>
                  <p>Parameter ID : ${response.data.data.parameterId}</p>
               </div>`,
        }).then(() => {
          navigate(`/device/${deviceId}`)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    } else if (parameterType === 'status_parameter') {
      const payload = {
        gatewayId: deviceData.gateway_id,
        iconUrl:
          'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/status_parameter%2F258682998-765cb53b-7e26-4a95-a1a0-986381559617.png?alt=media&token=b1f45a54-02d2-4a34-8daa-b37363a02e42',
        name: parameterName,
        ownerId: parameterOwner,
        deviceId: deviceId,
        premium: deviceData.premium,
      }

      Swal.fire({
        title: 'Creating new parameter...',
        html: 'Please wait a moment.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      try {
        const response = await apiConnect.post(
          '/v1/status-parameters/create-new-status-parameter',
          payload
        )
        Swal.fire({
          icon: 'success',
          title: 'Create new parameter successfully!',
          html: `<div>
                  <p>Parameter Name : ${response.data.data.name}</p>
                  <p>Parameter ID : ${response.data.data.parameterId}</p>
               </div>`,
        }).then(() => {
          navigate(`/device/${deviceId}`)
        })
      } catch (error) {
        console.error('Error fetching data:', error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        })
      }
    }
  }

  const unitOptions = unitLists.map((unit) => ({
    value: unit.unit_id,
    label: unit.quantity_name + ' (' + unit.unit_symbol + ')',
    icon: deviceData?.premium ? unit.premium_parameter_icon : unit.parameter_icon,
  }))

  const handleParameterUnitChange = (selectedOption) => {
    setParameterUnit(selectedOption ? selectedOption.value : '') // เก็บ unit_id
  }

  // ตัว renderer สำหรับแสดง label + รูป
  const formatOptionLabel = ({label, icon}) => (
    <div className='d-flex align-items-center gap-3'>
      <img src={icon} alt='icon' style={{width: 24, height: 24}} />
      <span>{label}</span>
    </div>
  )

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder'>Create New Parameter to {deviceData?.name}</h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Home
              </Link>
            </li>

            <li className='breadcrumb-item pe-3'>
              <Link to={`/device/${deviceId}`} className='pe-3'>
                {deviceData?.name}
              </Link>
            </li>

            <li className='breadcrumb-item px-3 text-muted'>Create parameter</li>
          </ol>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Create New Parameter</h3>
          </div>
        </div>

        <div className='collapse show'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Parameter Type</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <Select
                  options={parameterOptions}
                  value={parameterOptions.find((option) => option.value === parameterType)} // Bind the value
                  onChange={(selectedOption) => setParameterType(selectedOption?.value)} // Handle change
                  classNamePrefix='react-select'
                />
              </div>
            </div>

            {parameterType === 'parameter' && (
              <>
                {/* Parameter name */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Parameter Name
                  </label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Parameter name'
                      value={parameterName}
                      onChange={(e) => setParameterName(e.target.value)}
                    />
                    {/* <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>234</div>
                    </div> */}
                  </div>
                </div>

                {/* Parameter Unit */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Parameter Unit
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={unitOptions}
                      value={unitOptions.find((option) => option.value === parameterUnit) || null}
                      onChange={(selectedOption) => setParameterUnit(selectedOption?.value || '')}
                      formatOptionLabel={formatOptionLabel}
                      isClearable
                      classNamePrefix='react-select'
                    />
                  </div>
                </div>

                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Parameter Icon</label>
                  <div className='col-lg-8'>
                    {iconUrl ? (
                      <img src={iconUrl} alt='Device Icon' className='w-100px h-100px' />
                    ) : (
                      <p>No Icon Available</p>
                    )}
                  </div>
                </div>

                {/* Owner */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Owner</label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Parameter name'
                      value={parameterOwner}
                      onChange={(e) => setParameterOwner(e.target.value)}
                    />
                  </div>
                </div>
              </>
            )}

            {parameterType === 'setting_parameter' && (
              <>
                {/* Parameter name */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Setting Parameter Name
                  </label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Setting Parameter name'
                      value={parameterName}
                      onChange={(e) => setParameterName(e.target.value)}
                    />
                    {/* <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>234</div>
                    </div> */}
                  </div>
                </div>

                {/* Parameter Unit */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Parameter Unit
                  </label>
                  <div className='col-lg-8 fv-row'>
                    <Select
                      options={unitOptions}
                      value={unitOptions.find((option) => option.value === parameterUnit) || null}
                      onChange={(selectedOption) => setParameterUnit(selectedOption?.value || '')}
                      formatOptionLabel={formatOptionLabel}
                      isClearable
                      classNamePrefix='react-select'
                    />
                  </div>
                </div>

                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    Setting Parameter Icon
                  </label>
                  <div className='col-lg-8'>
                    <img
                      src={
                        deviceData.premium
                          ? 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter_premium.png?alt=media&token=2617106e-4985-4347-96e5-523d62c50bad'
                          : 'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/Setting_parameter%2Fsetting_parameter.png?alt=media&token=7e3655c7-3ef6-4287-8610-8fbf133d41ee'
                      }
                      alt='Device Icon'
                      className='w-100px h-100px'
                    />
                  </div>
                </div>

                {/* Owner */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Owner</label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Parameter name'
                      value={parameterOwner}
                      onChange={(e) => setParameterOwner(e.target.value)}
                    />
                  </div>
                </div>
              </>
            )}

            {parameterType === 'status_parameter' && (
              <>
                {/* Parameter name */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    Status Parameter Name
                  </label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Status Parameter name'
                      value={parameterName}
                      onChange={(e) => setParameterName(e.target.value)}
                    />
                    {/* <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>234</div>
                    </div> */}
                  </div>
                </div>

                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    Status Parameter Icon
                  </label>
                  <div className='col-lg-8'>
                    <img
                      src={
                        'https://firebasestorage.googleapis.com/v0/b/dygistechplatform.appspot.com/o/status_parameter%2F258682998-765cb53b-7e26-4a95-a1a0-986381559617.png?alt=media&token=b1f45a54-02d2-4a34-8daa-b37363a02e42'
                      }
                      alt='Device Icon'
                      className='w-100px h-100px'
                    />
                  </div>
                </div>

                {/* Owner */}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Owner</label>

                  <div className='col-lg-8'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Parameter name'
                      value={parameterOwner}
                      onChange={(e) => setParameterOwner(e.target.value)}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button
              onClick={() => handleCreateParameter()}
              className='btn btn-primary'
              disabled={
                (parameterType === 'parameter' || parameterType === 'setting_parameter') &&
                (parameterName === '' || parameterUnit === '')
              }
            >
              Create new parameter
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export {CreateNewParameter}
